export default __webpack_public_path__ + "static/media/wechat.625282b4.png";